// utils/ossClient.js
import OSS from 'ali-oss';

export const getOSSClient = async () => {
  // 这里应该从你的后端获取临时凭证（推荐）
  const response = await fetch('/oss/getStsToken');
  const credentials = await response.json();

  return new OSS({
    region: credentials.region,
    accessKeyId: credentials.accessKeyId,
    accessKeySecret: credentials.accessKeySecret,
    stsToken: credentials.securityToken,
    bucket: credentials.bucket
  });
};